import { useEffect, useState } from "react";
import api from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";

export default function AdminQuotes() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/quotes").then((r) => {
      setItems(r.data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <div className="text-[10px] uppercase tracking-[0.28em] text-slate-500">Quote requests</div>
        <h1 className="font-display text-3xl md:text-4xl tracking-tighter font-medium mt-2">Incoming quote requests</h1>
      </div>

      <div className="grid md:grid-cols-5 gap-6">
        <div className="md:col-span-2 bg-white border border-slate-200 max-h-[70vh] overflow-auto mp-scroll">
          {loading && <div className="p-6 text-slate-400 text-sm">Loading…</div>}
          {!loading && items.length === 0 && <div className="p-6 text-slate-400 text-sm">No quote requests.</div>}
          {items.map((q) => (
            <button
              key={q.id}
              data-testid={`quote-item-${q.id}`}
              onClick={() => setSelected(q)}
              className={`block w-full text-left px-4 py-3 border-b border-slate-100 hover:bg-slate-50 ${
                selected?.id === q.id ? "bg-slate-50 border-l-2 border-l-[#1E40AF]" : ""
              }`}
            >
              <div className="flex items-baseline justify-between gap-2">
                <div className="font-medium text-sm truncate">{q.company || q.name}</div>
                <StatusBadge status={q.status} />
              </div>
              <div className="text-xs text-slate-500 mt-0.5 truncate">{q.service_type}</div>
              <div className="text-xs text-slate-500 mt-0.5 tabular-nums">{new Date(q.created_at).toLocaleString()}</div>
            </button>
          ))}
        </div>

        <div className="md:col-span-3 bg-white border border-slate-200 min-h-[70vh] p-6">
          {!selected ? (
            <div className="text-slate-400 text-sm">Select a request to view details.</div>
          ) : (
            <div data-testid="quote-detail">
              <div className="text-[10px] uppercase tracking-[0.28em] text-slate-500">Quote request</div>
              <h2 className="font-display text-2xl tracking-tighter mt-1">{selected.name}</h2>
              <div className="text-sm text-slate-600 mt-1">
                {selected.email} {selected.company ? `· ${selected.company}` : ""} {selected.phone ? `· ${selected.phone}` : ""}
              </div>

              <div className="mt-6 grid grid-cols-2 gap-4 text-sm">
                <Field k="Service type" v={selected.service_type} />
                <Field k="Property count" v={selected.property_count} />
                <Field k="Coverage area" v={selected.coverage_area || "—"} />
                <Field k="Received" v={new Date(selected.created_at).toLocaleString()} />
              </div>
              <div className="mt-6 text-xs uppercase tracking-[0.2em] text-slate-500">Notes</div>
              <p className="mt-2 text-slate-800 leading-relaxed whitespace-pre-wrap">{selected.notes || "—"}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function Field({ k, v }) {
  return (
    <div className="border border-slate-200 p-3">
      <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">{k}</div>
      <div className="mt-1 text-slate-800 tabular-nums">{v}</div>
    </div>
  );
}
